export default "__VITE_PUBLIC_ASSET__bc80ff2d__"